import * as React from 'react'
export const An = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 744.09 496.06" {...props}>
    <path
      d="M0 0h744.09v496.06H0z"
      style={{
        fillRule: 'evenodd',
        strokeWidth: '1pt',
        fill: '#fff',
      }}
    />
    <path
      d="M288.18 0h167.74v496.06H288.18z"
      style={{
        fillRule: 'evenodd',
        strokeWidth: '1pt',
        fill: '#df0000',
      }}
    />
    <path
      d="M0 164.16h744.09V331.9H0z"
      style={{
        fillRule: 'evenodd',
        strokeWidth: '1pt',
        fill: '#00319c',
      }}
    />
    <path
      d="m320.35 270.32-14.61-10.79-14.54 10.4 5.77-16.48-14.62-10.76 17.56-.12 6.15-16.22 5.59 16.33 17.74-.17-14.06 10.95 5.02 16.86zM451.96 270.32l-14.62-10.79-14.54 10.4 5.77-16.48-14.61-10.76 17.56-.12 6.15-16.22 5.59 16.33 17.74-.17-14.07 10.95 5.03 16.86zM386.99 221.46l-14.62-10.8-14.54 10.41 5.77-16.49-14.61-10.75 17.56-.13 6.15-16.22 5.59 16.33 17.74-.17-14.07 10.96 5.03 16.86z"
      style={{
        fillRule: 'evenodd',
        fill: '#fff',
      }}
    />
    <path
      d="m386.99 221.46-14.62-10.8-14.54 10.41 5.77-16.49-14.61-10.75 17.56-.13 6.15-16.22 5.59 16.33 17.74-.17-14.07 10.96 5.03 16.86zM386.99 320.4l-14.62-10.79-14.54 10.41 5.77-16.49-14.61-10.75 17.56-.13 6.15-16.22 5.59 16.33 17.74-.17-14.07 10.95 5.03 16.86z"
      style={{
        fillRule: 'evenodd',
        fill: '#fff',
      }}
    />
  </svg>
)
